import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { AuthShell } from "@/pages/Login";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { applyAuth } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      applyAuth(data);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start building on the Standard plan — free.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="space-y-2">
          <Label className="text-xs text-muted-foreground">Name</Label>
          <Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)}
            placeholder="Ada Lovelace" className="bg-card border-border h-11" />
        </div>
        <div className="space-y-2">
          <Label className="text-xs text-muted-foreground">Email</Label>
          <Input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            required placeholder="you@company.com" className="bg-card border-border h-11" />
        </div>
        <div className="space-y-2">
          <Label className="text-xs text-muted-foreground">Password</Label>
          <Input data-testid="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            required minLength={6} placeholder="min. 6 characters" className="bg-card border-border h-11" />
        </div>
        {error && <p data-testid="register-error" className="text-sm text-kinetic font-mono">{error}</p>}
        <Button data-testid="register-submit" type="submit" disabled={loading}
          className="w-full h-11 bg-white text-black hover:bg-zinc-200 font-medium">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Create account <ArrowRight className="w-4 h-4 ml-1" /></>}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        Already have an account? <Link to="/login" data-testid="to-login" className="text-white hover:text-kinetic transition-colors">Sign in</Link>
      </p>
    </AuthShell>
  );
}
